import {
  Component,
  HostListener,
  Inject,
  Output,
  EventEmitter
} from "@angular/core";
import { DOCUMENT } from "@angular/platform-browser";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { environment } from "../../environments/environment";

import * as $ from "jquery";
import * as _ from "underscore";
import * as moment from "moment";
declare var Carousel: any;

import { AuthComponent } from "../login/auth.component";
import { LoginService } from "../login/login.service";
import { ProductsService } from "./products.service";
import { ListService } from "../list/list.service";
import { FiltersService } from "./filters.service";
import { SpService } from "./sales-presenters/sp.service";
import { OrderService } from "./order.service";

@Component({
  selector: "app-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.css"],
  providers: [
    ProductsService,
    LoginService,
    ListService,
    FiltersService,
    SpService,
    OrderService
  ]
})
export class ProductsComponent extends AuthComponent {
  @Output("notesEvent") notesEvent = new EventEmitter();

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    if (this.nextSkip == "done") {
      this.isLoadingMore = false;
      return;
    }
    if (this.isLoadingMore) {
      return;
    }
    let scrollBottom =
      document.documentElement.scrollTop +
      document.documentElement.clientHeight;
    let cutOff = document.documentElement.scrollHeight - 600;
    if (scrollBottom > cutOff) {
      this.loadMoreProducts();
    }
  }

  private isSearchHidden: boolean = true;
  private isNavHidden = true;
  private originalProducts = null;

  private isLoading = true;
  private isProductLoading = false;
  private isLoadingMore = false;

  private products = null;
  private lists = null;
  private listName = null;
  private listId = null;
  private userId = null;
  private region = null;
  private season = null;
  private downloadLinks = [];
  private nextSkip: any = 0;
  private displaySeason = null;
  private imageUnavailablePath = "/assets/images/image_unavailable_medium.jpg";
  private activeAsrt = null;
  private asrtHeaderHeight = 170;
  private asrtContent;
  private isChangeListHidden = true;
  private isCustomerList = false;
  private isCustomerLoggedIn = false;

  private removeTemporarily: boolean = true;

  private filterData = null;
  private filterKeys = null;
  public queryFilterData = null;

  public downloadOptions = false;
  public onDisplayBiggerImage = false;
  public topImageIndex;
  public asrtImageIndex;
  public collImageIndex;
  public topImage = {};
  public thumbImageIndex;
  public groupColorIndex;
  public groupedColors;
  public idIndex = {};
  public clickableIdx;
  public activeIdx = null;
  public activeRowIndex;
  public activeCollIndex;
  public activeAsrtIndex;

  public activeImgIdx = 0;

  public magicLink = null;

  public filterVals = null;
  public filterAllValues = [];
  public updatedFacetValues = [];
  public filter_data;
  public activeFilter = false;
  public isSalesPresentExists = false;
  public filterSelected;
  public country;
  updatedValues: any = {};
  public filterModal: boolean = false;
  private isConfirmed: boolean = false;

  public ENV = environment;

  orderModalItem = null;

  constructor(
    router: Router,
    loginService: LoginService,
    private route: ActivatedRoute,
    private productsService: ProductsService,
    private listService: ListService,
    private filtersService: FiltersService,
    private spService: SpService,
    private orderService: OrderService
  ) {
    super(router, loginService);
    this.init().then(() => {
      this.route.queryParams.subscribe((params: Params) => {
        let listName = params["list_name"];
        if (listName) {
          this.listName = listName;
        } else if (localStorage) {
          this.listName = localStorage.getItem("list_name");
        }

        let userId = params["user_id"];
        if (userId) {
          this.userId = userId;
        } else if (localStorage) {
          this.userId = localStorage.getItem("user_id");
        }

        let season = params["season"];

        if (season) {
          this.season = season;
        } else if (localStorage) {
          this.season = localStorage.getItem("season");
        }
        this.displaySeason = this.getAbbrDisplaySeason(this.season);

        localStorage.setItem("display_season", this.displaySeason);

        if (localStorage && localStorage.getItem("magic_link")) {
          this.magicLink = localStorage.getItem("magic_link");
        }

        let retailFilt = localStorage.getItem("filter_values");
        if (retailFilt && retailFilt.length > 0) {
          this.filterKeys = JSON.parse(retailFilt);
        }
        let filetrs = localStorage.getItem("appliedFilterValues");
        if (filetrs && Object.keys(filetrs).length > 0) {
          this.updatedValues = JSON.parse(filetrs);
          this.udpateFilterFacets();
        }
        let filters = {
          list_name: this.listName,
          user_id: this.userId,
          season: this.season,
          filter: this.getRequiredFilters()
        };
        this.loadProducts(filters);
      });
    });
  }

  getAbbrDisplaySeason(season) {
    season = season || "";
    let dispSeason = season.split("-");
    if (dispSeason && dispSeason[0]) {
      dispSeason = dispSeason[0].toUpperCase();
      if (dispSeason.startsWith("AW")) {
        return "AW" + dispSeason.substr(4, 2);
      } else if (dispSeason.startsWith("SS")) {
        return "SS" + dispSeason.substr(4, 2);
      } else {
        return season;
      }
    } else {
      return "";
    }
  }
  ngOnInit() {
    $(window)
      .scroll(function () {
        var scrollDistance = $(window).scrollTop() + 300;

        // Assign active class to nav links while scolling
        $(".page-sections").each(function (i) {
          if ($(this).position().top <= scrollDistance) {
            $(".navmenu ul li a.active").removeClass("active");
            $(".navmenu ul li a").eq(i).addClass("active");
          }
        });
      })
      .scroll();
  }

  removeFilterFacet(val) {
    this.updatedFacetValues = this.updatedFacetValues.filter(
      as => !(as.key == val.key && as.subKey == val.subKey)
    );

    if (val.key && this.updatedValues[val.key]) {
      this.removeFitler(val.key, val.subKey);
    }
    if (val.originalKey && this.updatedValues[val.originalKey]) {
      this.removeFitler(val.originalKey, val.originalSubkey);
    }
  }

  removeFitler(key, subKey) {
    if (key && this.updatedValues[key]) {
      if (this.updatedValues[key] && this.updatedValues[key].includes(subKey)) {
        let index = this.updatedValues[key].indexOf(subKey);
        this.updatedValues[key].splice(index, 1);
      }
      if (key == "search") {
        delete this.updatedValues[key];
      }

      localStorage.setItem(
        "appliedFilterValues",
        JSON.stringify(this.updatedValues)
      );

      this.refreshProduct();
    }
  }

  clearAllFilters() {
    this.updatedValues = {};
    this.updatedFacetValues = [];
    localStorage.setItem(
      "appliedFilterValues",
      JSON.stringify(this.updatedValues)
    );
    this.refreshProduct();
  }

  onDownload(): any {
    this.downloadOptions = !this.downloadOptions;
  }
  closeDownloadOptions(): any {
    this.downloadOptions = false;
  }

  clickNavMenu(asrt) {
    var mobileWindow = $(window).width() <= 800;
    if (mobileWindow) {
      $(".navbar-toggle").click();
    }
    $("html,body").animate(
      {
        scrollTop: $("#" + asrt.classname).offset().top - 200
      },
      1000
    );
    return false;
  }

  loadList() {
    if (this.isUserBelongsToCustomer()) {
      return this.listService.getUsersLists().then(res => {
        this.lists = res;
        this.lists = this.lists.filter(as => as.customer_magic_link);
        return Promise.resolve();
      });
    } else {
      this.lists = [];
      return Promise.resolve();
    }
  }

  isUserBelongsToCustomer() {
    if (this.loggedInUser) {
      return this.loggedInUser["role"] == "customer";
    } else {
      return false;
    }
  }

  isListBelongsToCustomer() {
    if (this.lists && this.listName) {
      let list = _.findWhere(this.lists, {
        list_name: this.listName,
        user_id: this.userId,
        season: this.season
      });
      if (list) {
        return list["role"] == "customer";
      } else {
        return false;
      }
    }
  }

  loadProducts(filters, isFilterApplied = false) {
    this.isProductLoading = !isFilterApplied;
    if (localStorage.hasOwnProperty("product_data")) {
      //Coming back from detail
      this._setResponseFromCache();
      this.isLoading = false;
      this.isProductLoading = false;
      this.scrollToSelectedProduct();
      return Promise.resolve();
    }

    let promises = [];

    promises.push(this.loadList());
    promises.push(this.productsService.list(filters));

    return Promise.all(promises)
      .then(res => {
        if (res[1]) {
          this.region = res[1].name;
          this.listId = res[1].list_id;
          this.isConfirmed = res[1].confirmed;
          this.country = res[1].country;
        }

        this.nextSkip = res[1]["next_skip"] || "done";
        this.products = this.formatProducts(res[1]);
        this.downloadLinks = this._formatDownloadLinks();
        this.originalProducts = Object.assign({}, this.products);
        if (this.products["assortments"] && this.products["assortments"][0]) {
          this.activeAsrt = this.products["assortments"][0]["classname"];
        }
        this.setLocalStorage();
        this.isCustomerList = this.isListBelongsToCustomer();
        this.isCustomerLoggedIn = this.isUserBelongsToCustomer();
        if (this.updatedValues && this.updatedValues.length == 0) {
          this.isLoading = false;
          this.isProductLoading = false;
          this.scrollToSelectedProduct();
        }

        return this.filtersService.getFilters(
          this.season,
          this.region,
          this.listId,
          this.country,
          this.getRequiredFilters()
        );
      })
      .then(res => {
        this.filterData = res.filters;
        this.formatFilterOrders();
      })
      .then(res => {
        return this.spService.getSalesPresenters(
          this.season,
          this.region,
          this.country,
          true
        );
      })
      .then(res => {
        this.isSalesPresentExists = res.count && res.count > 0 ? true : false;
        this.isLoading = false;
        this.isProductLoading = false;
        this.scrollToSelectedProduct();
      })
      .catch(e => {
        console.error(e);
        this.isLoading = false;
        this.isProductLoading = false;
        this.router.navigateByUrl("/error/not-authorised");
        // this.handleError(e);
      });
  }

  loadMoreProducts() {
    this.isLoadingMore = true;

    let filters = {
      list_name: this.listName,
      user_id: this.userId,
      season: this.season,
      filter: this.getRequiredFilters()
    };
    filters["skip"] = this.nextSkip;
    return this.productsService.list(filters).then(res => {
      let data = this.formatProducts(res);
      let tmp = this._mergeProducts(this.products, data, [
        { array_key: "assortments", compare_key: "name" },
        { array_key: "collections", compare_key: "name" },
        { array_key: "items", compare_key: "name" },
        { array_key: "colors", compare_key: null }
      ]);
      this.products = this.formatProducts(tmp);
      this.originalProducts = Object.assign({}, this.products);
      this._formatDownloadLinks();
      this.nextSkip = res["next_skip"];
      this.isLoadingMore = false;
    });
  }

  handleScroll(e) {
    if (this.isLoadingMore) {
      return;
    }

    let el = e.srcElement || e.target;
    if (!el) {
      return;
    }

    let scrollBottom = el.offsetHeight + el.scrollTop;
    let scrollHeight = el.scrollHeight;
    let cutOff = scrollHeight - 150;
    if (scrollBottom > cutOff) {
      this.loadMoreProducts();
    }
  }

  scrollToSelectedProduct() {
    if (localStorage.hasOwnProperty("product_data")) {
      let scrollToProduct = localStorage.getItem("product_data");
      let itemWithoutDot = scrollToProduct.replace(/\./g, "");
      let itemWithoutSpace = itemWithoutDot.replace(/\s+/g, "-");
      let mobileScreen = $(window).width() <= 1100;
      let topHeaderWidth = mobileScreen ? 35 : 253;

      setTimeout(() => {
        let el = $("#" + itemWithoutSpace);
        if (el.length > 0) {
          let topWidth = el.offset().top - topHeaderWidth;
          $("html,body").animate({ scrollTop: topWidth }, 1000);
        }
      }, 1000);

      localStorage.removeItem("product_data");
    }
  }

  setLocalStorage() {
    if (localStorage) {
      if (this.isConfirmed) {
        localStorage.setItem("confirmed", "true");
      }
      localStorage.setItem("list_name", this.listName);
      localStorage.setItem("user_id", this.userId);
      localStorage.setItem("season", this.season);
    }
  }

  formatProducts(data) {
    for (let asrt of data["assortments"]) {
      asrt["classname"] = this.sanitiseName(asrt.name);
      for (let coll of asrt["collections"]) {
        for (let item of coll["items"]) {
          item["detailclass"] = this.sanitiseNameWithoutDot(item.name, item.id);
          item["groupedColors"] = [];
          let i = 0;
          let tmpColors = [];
          let allcolors = this.getAllIds(item);
          for (let color of item["colors"]) {
            this.setOrdersInStorage(color);
            let fitting = "";
            if (color.fit) fitting += color.fit;
            if (color.size) fitting += "/" + color.size;
            if (this.region == "AMERICAS" && color.us_fits) {
              fitting = color.us_fits;
            }
            color["fitting"] = fitting;

            if (color && color.rrp_price) {
              let rrp = color.rrp_price;
              if (rrp.value != "0") {
                if (rrp.value && Array.isArray(rrp.value)) {
                  color["rrp"] = rrp.value.map(v => rrp.code + " " + v);
                } else {
                  color["rrp"] = rrp.code + " " + rrp.value;
                }
                color["is_us"] = rrp.code == "USD" ? true : false;
              }
            }

            color["style"] = item.name;
            color["lining"] = item.lining;
            color["sock"] = item.sock;
            color["upper"] = item.upper;
            color["construction"] = item.construction;
            color["sole"] = item.sole;
            color["fit"] = item.fit;
            color["status"] = item.status;
            color["all_colors"] = allcolors.toString();
            color["heel_height"] = item.heel_height;
            this.loadColorOrder(color);
            tmpColors.push(color);
            i += 1;
            //So, only 4 colors will be shown in one row
            if (i % 4 == 0) {
              item["groupedColors"].push(tmpColors);
              tmpColors = [];
            }
          }

          if (tmpColors.length > 0) {
            item["groupedColors"].push(tmpColors);
          }
        }
      }
    }
    return data;
  }

  _formatDownloadLinks() {
    //ToDo: This needs to be done from respective projects itself
    let downloadLinks = [];
    if (this.products && this.products.is_all) {
      return downloadLinks;
    }

    if (Array.isArray(this.products.downloads)) {
      for (let download of this.products.downloads) {
        if (download.link) {
          downloadLinks.push({ label: download.label, link: download.link });
        } else {
          downloadLinks.push({ label: "Your downloads are being prepared..." });
        }
      }
    }

    if (["clarks", "lns"].indexOf(this.ENV.image_folder) == -1) {
      return downloadLinks;
    }

    if (
      !(
        this.products &&
        this.products.assortments &&
        this.products.assortments[0]
      )
    ) {
      downloadLinks.push({
        label: "Please add in few products to the list, before downloading..."
      });
    }

    if (
      this.products &&
      this.products.assortments &&
      this.products.assortments[0] &&
      !this.products.is_export_updated
    ) {
      downloadLinks.push({
        label:
          "You do not have any downloads available right now. Please contact Clarks salesperson..."
      });
    }

    if (
      this.products &&
      this.products.is_export_updated &&
      (!this.products.exported_pdf_link ||
        this.products.exported_pdf_link == "NA" ||
        !this.products.exported_landscape_link ||
        this.products.exported_landscape_link == "NA" ||
        !this.products.exported_zip_link ||
        !this.products.exported_zip_link.large ||
        !this.products.exported_zip_link.thumb ||
        !this.products.exported_csv_link)
    ) {
      downloadLinks.push({ label: "Your downloads are being updated..." });
    }

    if (this.products.exported_pdf_link) {
      if (this.products.exported_pdf_link == "NA") {
        downloadLinks.push({ label: "Your downloads are being updated..." });
      } else {
        downloadLinks.push({
          label: "Portrait PDF",
          link: this.products.exported_pdf_link
        });
      }
    }
    if (this.products.exported_landscape_link) {
      if (this.products.exported_landscape_link !== "NA") {
        downloadLinks.push({
          label: "Landscape PDF",
          link: this.products.exported_landscape_link
        });
      }
    }
    if (this.products.exported_zip_link) {
      if (this.products.exported_zip_link.large) {
        downloadLinks.push({
          label: "High-res images",
          link: this.products.exported_zip_link.large
        });
      }
      if (this.products.exported_zip_link.thumb) {
        downloadLinks.push({
          label: "Low-res images",
          link: this.products.exported_zip_link.thumb
        });
      }
    }
    if (this.products.exported_csv_link) {
      if (this.products.exported_csv_link !== "NA") {
        downloadLinks.push({
          label: "Excel",
          link: this.products.exported_csv_link
        });
      }
    }

    return downloadLinks;
  }

  getAllIds(item) {
    let colorList = [];
    for (let col of item["colors"]) {
      colorList.push(col.id);
    }
    return _.uniq(colorList);
  }

  getThumbImage(image) {
    if (image) {
      return image;
    } else {
      return this.imageUnavailablePath;
    }
  }

  toggleNav() {
    this.isNavHidden = !this.isNavHidden;
  }

  showChangeList() {
    this.isChangeListHidden = !this.isChangeListHidden;
  }

  changeListClicked() {
    this.isLoading = true;
    return true;
  }

  sanitiseName(asrtName) {
    return asrtName.split(" ").join("-");
  }
  sanitiseNameWithoutDot(itemName, itemId) {
    let itemWithoutDot = itemName.replace(/\./g, "");
    let itemWithoutSpace = itemWithoutDot.replace(/\s+/g, "-");
    return itemWithoutSpace;
  }

  formatFilterOrders() {
    if (
      this.filterData &&
      Array.isArray(this.filterData) &&
      this.filterData.length > 0
    ) {
      this.filterKeys = this.filterData.map(as => as.label);
      localStorage.setItem("filter_values", JSON.stringify(this.filterKeys));
    } else {
      this.filterKeys = [];
    }
  }

  showFilterModal() {
    this.filterModal = true;
  }

  closeFilterModal() {
    this.filterModal = false;
  }

  updateFilterValue(key, valIdx, val, isChecked) {
    if (isChecked) {
      if (!this.updatedValues[key]) {
        this.updatedValues[key] = [];
      }
      if (!this.updatedValues[key].includes(val)) {
        this.updatedValues[key].push(val);
      }
      localStorage.setItem(
        "appliedFilterValues",
        JSON.stringify(this.updatedValues)
      );
    } else {
      if (this.updatedValues && this.updatedValues[key]) {
        if (this.updatedValues[key].includes(val)) {
          let index = this.updatedValues[key].indexOf(val);
          this.updatedValues[key].splice(index, 1);
        }
      }
    }

    localStorage.setItem(
      "appliedFilterValues",
      JSON.stringify(this.updatedValues)
    );

    this.udpateFilterFacets();
    this.refreshProduct();
  }

  udpateFilterFacets() {
    let filterArr = [];
    for (let i of Object.keys(this.updatedValues)) {
      if (this.updatedValues[i] && this.updatedValues[i].length > 0) {
        for (let f of this.updatedValues[i]) {
          let obj = {};
          let filterObj = (this.filterData || []).find(f => f.key === i);

          obj["key"] = filterObj ? filterObj.label : i;
          obj["originalKey"] = i; // we can change in what way we want to show
          // obj["subKey"] = f;
          // obj["originalSubkey"] = f;
          obj["subKey"] = f && f.display ? f.display : f;
          obj["originalSubkey"] = f && f.display ? f.display : f;
          filterArr.push(obj);
        }
      }
    }
    this.updatedFacetValues = filterArr;
  }

  applySearch(event) {
    let fields = event.fields;
    let obj = event.obj;
    this.updateFilterValue("search", 0, obj, true);
  }

  isFilterValueChecked(key, value, valIdx) {
    return (
      this.updatedValues &&
      this.updatedValues[key] &&
      this.updatedValues[key].indexOf(value) > -1
    );
  }

  refreshProduct() {
    let filters = {
      list_name: this.listName,
      user_id: this.userId,
      season: this.season,
      filter: this.getRequiredFilters()
    };

    this.loadProducts(filters);
  }

  getRequiredFilters() {
    let newFilters = {};
    for (let f of Object.keys(this.updatedValues)) {
      if (this.updatedValues[f] && this.updatedValues[f].length > 0) {
        newFilters[f] = this.updatedValues[f];
      }
    }
    return JSON.stringify(newFilters);
  }

  showFilterValues(key) {
    if (this.filterData && this.filterData.length > 0) {
      let filterVal = this.filterData.filter(as => as.label == key);
      if (filterVal && filterVal[0] && filterVal[0].options) {
        this.filterAllValues = filterVal[0].options;
        this.filterVals = filterVal[0].key;
      }
    }
  }

  hideFilterVals() {
    this.filterVals = null;
  }

  openProduct(e, asrt, coll, item, color, season, country, listId) {
    this._cacheResponses();

    this.router.navigate(["/product-summary"], {
      queryParams: {
        assortment: asrt.name,
        collection: coll.name,
        style: item.name,
        family: color.style_name,
        color: color.id,
        colors: color.all_colors,
        season: season,
        country: country || color.country,
        listId: listId
      }
    });
  }

  _cacheResponses() {
    let cachedVars = [
      "lists",
      "region",
      "listId",
      "country",
      "products",
      "originalProducts",
      "activeAsrt",
      "isCustomerList",
      "isCustomerLoggedIn",
      "filterData",
      "filterKeys",
      "isSalesPresentExists",
      "downloadLinks",
      "nextSkip"
    ];
    for (let varName of cachedVars) {
      localStorage.setItem("cache_" + varName, JSON.stringify(this[varName]));
    }
  }

  _setResponseFromCache() {
    let cachedVars = [
      "lists",
      "region",
      "listId",
      "country",
      "products",
      "originalProducts",
      "activeAsrt",
      "isCustomerList",
      "isCustomerLoggedIn",
      "filterData",
      "filterKeys",
      "isSalesPresentExists",
      "downloadLinks",
      "nextSkip"
    ];
    for (let varName of cachedVars) {
      let key = "cache_" + varName;
      let val = localStorage.getItem(key);
      if (val) {
        try {
          this[varName] = JSON.parse(val);
        } catch (e) {
          this[varName] = null;
        }
      }
    }
  }

  loadColorOrder(color: any) {
    let saved: any = localStorage.getItem(color.id);
    saved = saved ? JSON.parse(saved) : {};

    if (!color.sizes) {
      color.sizes = saved.sizes ? saved.sizes : null;
    }

    if (!color.wholesale) {
      color.wholesale = saved.wholesale ? saved.wholesale : null;
    }

    color.orders = saved.orders ? saved.orders : null;

    if (!color.sizes) {
      color.sizes = [
        "6",
        "6½",
        "7",
        "7½",
        "8",
        "8½",
        "9",
        "9½",
        "10",
        "10½",
        "11",
        "11½",
        "12"
      ];
    }
    if (!color.orders) {
      color.orders = {};
    }

    if (!color.wholesale) {
      color.wholesale = 15 + Math.floor(Math.random() * 10);
    }
  }

  setOrdersInStorage(color) {
    localStorage.setItem(
      color.id,
      JSON.stringify({
        sizes: color.sizes,
        orders: color.orders,
        wholesale: color.wholesale
      })
    );
  }

  saveColorOrder(color: any) {
    let orderObj = {
      total: this.orderTotal(color),
      orders: color.orders,
      list_id: this.listId,
      id: color.id
    };
    let promises = [];
    promises.push(this.orderService.update(orderObj));

    return Promise.all(promises)
      .then(res => {
        this.setOrdersInStorage(color);
      })
      .catch(e => {
        console.error(e);
        this.router.navigateByUrl("/error/not-authorised");
      });
  }

  confirmOrder() {
    if (this.isConfirmed) {
      return;
    }
    let confirmedByUser = confirm("Are you sure?");
    if (!confirmedByUser) {
      return;
    }
    return this.orderService
      .update({ confirmed: true, id: this.listId })
      .then(res => {
        this.isConfirmed = true;
        if (localStorage.hasOwnProperty("user_details")) {
          let userDetails = localStorage.getItem("user_details");
          let tmpuserDetails = JSON.parse(userDetails);
          if (tmpuserDetails) {
            tmpuserDetails.confirmed = true;
          }
          localStorage.setItem("user_details", JSON.stringify(tmpuserDetails));
        }
      })
      .catch(e => {
        console.error(e);
        this.router.navigateByUrl("/error/not-authorised");
      });
  }

  openOrderModal(color, e) {
    e.stopPropagation();
    e.preventDefault();
    this.loadColorOrder(color);
    let pos = e.srcElement.getBoundingClientRect();
    color.left = pos.right + 10;
    color.top = (pos.top + pos.bottom) / 2 + window.scrollY;
    if (color.left > 0.65 * window.innerWidth) {
      color.left = pos.left - 0.3 * window.innerWidth - 10;
    }

    this.orderModalItem = color;
  }

  orderPairs(color) {
    if (!color.orders) {
      return "0";
    }
    let retval = 0;
    for (let order in color.orders) {
      let val = parseInt(color.orders[order]);

      retval += isNaN(val) ? 0 : val;
    }
    return retval.toLocaleString("en-gb");
  }

  confirmedText() {
    return this.isConfirmed ? "Confirmed" : "Confirm Order";
  }

  orderTotal(color) {
    if (!color.wholesale) {
      return "0";
    }
    let orderTotal =
      parseFloat(this.orderPairs(color).replace(/,/g, "")) * color.wholesale;
    return orderTotal.toFixed(2);
  }

  overallPairs() {
    let totalPairs = 0;
    for (let assortment of this.products.assortments) {
      for (let coll of assortment.collections) {
        for (let item of coll.items) {
          for (let color of item.colors) {
            let val = parseInt(this.orderPairs(color));
            totalPairs += isNaN(val) ? 0 : val;
          }
        }
      }
    }
    return totalPairs.toLocaleString("en-gb");
  }

  overallTotal() {
    let total = 0;
    for (let assortment of this.products.assortments) {
      for (let coll of assortment.collections) {
        for (let item of coll.items) {
          for (let color of item.colors) {
            let val = parseFloat(this.orderTotal(color));
            total += isNaN(val) ? 0 : val;
          }
        }
      }
    }
    return total;
  }
  orderBy() {
    return this.products.order_by;
  }

  number(val) {
    let retval = parseFloat(val);
    return isNaN(retval) ? 0 : retval;
  }

  _mergeProducts(olderProd, newProd, groups) {
    if (!olderProd) {
      return {};
    }
    if (groups.length == 0) {
      return olderProd;
    }
    let g = groups.shift();

    let olderG = olderProd[g["array_key"]];
    let lastOlderIdx = olderG.length - 1;
    let lastOlderG = Object.assign({}, olderG[lastOlderIdx]);

    let newG = newProd[g["array_key"]];
    let firstNewG = Object.assign({}, newG[0]);
    if (!firstNewG) {
      return olderProd;
    }

    if (
      g["compare_key"] &&
      lastOlderG[g["compare_key"]] == firstNewG[g["compare_key"]]
    ) {
      olderG[lastOlderIdx] = this._mergeProducts(lastOlderG, firstNewG, groups);
      let removeFirstG = newG.shift();
      olderG = olderG.concat(newG);
    } else {
      olderG = olderG.concat(newG);
    }

    olderProd[g["array_key"]] = olderG;
    return olderProd;
  }
}



// WEBPACK FOOTER //
// ./src/app/products/products.component.ts